import React from 'react';
import DatePicker from 'react-datepicker';
import { Container } from 'reactstrap';
import { BsCalendar2Date } from 'react-icons/bs';
import CreatableSelect from 'react-select/creatable';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';

import GroupUsageRateTable from './components/GroupUsageRateTable';
import WorkflowUsageRateViewModel from './WorkflowUsageRate.viewmodel';

import {
    getMonthStartAndEnd,
    parseDateFromYYYYMMDD
} from '../../../modules/Common';
import { MasterCompany } from '../../../models/company/MasterCompany';

// Custom styles
const customStyles = {
    multiValueRemove: (base, state) => {
        return state.data.isFixed
            ? { ...base, display: 'none', zIndex: 'auto' }
            : base;
    },
    menu: provided => ({
        ...provided,
        zIndex: 9999
    })
};

const wfTypeColour = [
    '#6D6875',
    '#B5838D',
    '#E5989B',
    '#FFB4A2',
    '#FFCDB2',
    '#CDB4DB',
    '#FFAFCC',
    '#BDE0FE',
    '#A2D2FF',
    '#0096C7'
];

export default function WorkflowUsageRateView() {
    const {
        selectedTab,
        setSelectedTab,
        searchInputs,
        adminCompanyOptions,
        selectedCompany,
        handleSelectCompany,
        workflowUsageRate,
        workflowUsageRateDetail,
        ExportExcel,
        handleSearch,
        handleSearchInputChange
    } = WorkflowUsageRateViewModel();

    return (
        <Container fluid>
            <Row>
                <Col className="import-export-actions">
                    <div className="trapezoid-head w-[250px]">
                        <span>Workflow Usage Rate</span>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="mat-box">
                        <div className="trapezoid trapezoid-purple inline-block w-[200px]">
                            <span>
                                <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                ></i>
                                Search menu
                            </span>
                        </div>

                        <div className="mat-box mb-5 rounded bg-white p-3 shadow">
                            <Row>
                                <Col>
                                    <div className="mt-2">
                                        <Row className="gy-3">
                                            <Col sm={6}>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="formBasicEmail"
                                                >
                                                    <Form.Label>
                                                        Company Name :
                                                    </Form.Label>
                                                    <div
                                                        style={{ zIndex: 2000 }}
                                                    >
                                                        <CreatableSelect
                                                            isMulti
                                                            isClearable
                                                            options={
                                                                adminCompanyOptions
                                                            }
                                                            getOptionLabel={(
                                                                company: MasterCompany
                                                            ) =>
                                                                company.company_name
                                                            }
                                                            getOptionValue={(
                                                                company: MasterCompany
                                                            ) => company.sid}
                                                            value={
                                                                selectedCompany
                                                            }
                                                            onChange={
                                                                handleSelectCompany
                                                            }
                                                            styles={
                                                                customStyles
                                                            }
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                                className="d-flex align-items-end justify-center"
                                            >
                                                <div className="w-100 mb-3 flex h-[38px] space-x-4 text-center">
                                                    <Button
                                                        variant="outline-info"
                                                        size="sm"
                                                        className="w-full sm:w-auto"
                                                        onClick={handleSearch}
                                                    >
                                                        <div className="flex items-center">
                                                            <FaSearch /> Search
                                                        </div>
                                                    </Button>

                                                    <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        className="w-full sm:w-auto"
                                                        onClick={ExportExcel}
                                                    >
                                                        <div className="flex items-center">
                                                            <FaPlusCircle />{' '}
                                                            &nbsp;Export Excel
                                                        </div>
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="gy-3">
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                            >
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="startDate"
                                                >
                                                    <Form.Label>
                                                        Date From :{' '}
                                                        <BsCalendar2Date />
                                                    </Form.Label>

                                                    {/*<DatePicker*/}
                                                    {/*    wrapperClassName="w-100"*/}
                                                    {/*    className="w-100"*/}
                                                    {/*    customInput={*/}
                                                    {/*        <Form.Control className="menu-form custom-datepicker"/>*/}
                                                    {/*    }*/}
                                                    {/*    selected={parseDateFromYYYYMMDD(*/}
                                                    {/*        searchInputs.sdate*/}
                                                    {/*    )}*/}
                                                    {/*    dateFormat="dd/MM/yyyy"*/}
                                                    {/*    onChange={date => {*/}
                                                    {/*        handleSearchInputChange(*/}
                                                    {/*            'sdate',*/}
                                                    {/*            String(*/}
                                                    {/*                convertToYYYYMMDD(*/}
                                                    {/*                    date?.toISOString()!*/}
                                                    {/*                )*/}
                                                    {/*            ).substring(*/}
                                                    {/*                0,*/}
                                                    {/*                8*/}
                                                    {/*            )*/}
                                                    {/*        );*/}
                                                    {/*    }}*/}
                                                    {/*/>*/}

                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="w-100"
                                                        customInput={
                                                            <Form.Control className="menu-form custom-datepicker" />
                                                        }
                                                        selected={parseDateFromYYYYMMDD(
                                                            searchInputs.sdate
                                                        )}
                                                        onChange={date => {
                                                            handleSearchInputChange(
                                                                'sdate',
                                                                getMonthStartAndEnd(
                                                                    date
                                                                ).start
                                                            );
                                                        }}
                                                        dateFormat="MM/yyyy"
                                                        showMonthYearPicker
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                            >
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="endDate"
                                                >
                                                    <Form.Label>
                                                        Date To :{' '}
                                                        <BsCalendar2Date />
                                                    </Form.Label>

                                                    {/*<DatePicker*/}
                                                    {/*    wrapperClassName="w-100"*/}
                                                    {/*    className="w-100"*/}
                                                    {/*    customInput={*/}
                                                    {/*        <Form.Control className="menu-form custom-datepicker"/>*/}
                                                    {/*    }*/}
                                                    {/*    selected={parseDateFromYYYYMMDD(*/}
                                                    {/*        searchInputs.edate*/}
                                                    {/*    )}*/}
                                                    {/*    dateFormat="dd/MM/yyyy"*/}
                                                    {/*    onChange={date => {*/}
                                                    {/*        handleSearchInputChange(*/}
                                                    {/*            'edate',*/}
                                                    {/*            String(*/}
                                                    {/*                convertToYYYYMMDD(*/}
                                                    {/*                    date?.toISOString()!*/}
                                                    {/*                )*/}
                                                    {/*            ).substring(*/}
                                                    {/*                0,*/}
                                                    {/*                8*/}
                                                    {/*            )*/}
                                                    {/*        );*/}
                                                    {/*    }}*/}
                                                    {/*/>*/}

                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="w-100"
                                                        customInput={
                                                            <Form.Control className="menu-form custom-datepicker" />
                                                        }
                                                        selected={parseDateFromYYYYMMDD(
                                                            searchInputs.edate
                                                        )}
                                                        onChange={date => {
                                                            handleSearchInputChange(
                                                                'edate',
                                                                getMonthStartAndEnd(
                                                                    date
                                                                ).end
                                                            );
                                                        }}
                                                        dateFormat="MM/yyyy"
                                                        showMonthYearPicker
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            <Tabs
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                value={selectedTab}
            >
                <div
                    className="nav-item"
                    onClick={() => setSelectedTab(0)}
                >
                    <a className="pointer">
                        <div
                            id="trapezoidTap0"
                            className={`${
                                selectedTab ? '' : 'active'
                            } trapezoid trapezoid-purple`}
                            style={{ width: '230px' }}
                        >
                            <span>
                                <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                ></i>
                                Created Workflow
                            </span>
                        </div>
                    </a>
                </div>
                <div
                    className="nav-item"
                    onClick={() => setSelectedTab(1)}
                >
                    <a className="pointer">
                        <div
                            id={'trapezoidTap1'}
                            className={`${
                                selectedTab ? 'active' : ''
                            } trapezoid`}
                            style={{
                                width: '230px',
                                borderBottom: '32px solid ' + wfTypeColour[0]
                            }}
                        >
                            <span>
                                <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                ></i>
                                Callback
                            </span>
                        </div>
                    </a>
                </div>
            </Tabs>

            <Row className="mt-4">
                <Col>
                    <div style={{ overflowX: 'auto' }}>
                        <GroupUsageRateTable
                            selectedTab={selectedTab}
                            // workflowUsageRates={workflowUsageRate}
                            workflowUsageRateDetails={workflowUsageRateDetail}
                        />
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
